import { Box, LinearProgress, Paper, Typography } from "@mui/material";
import { useMemo } from "react";
import { MemoryMessage } from "../hooks/useMemoryMessages";

interface ContactTypesSidebarProps {
  messages: MemoryMessage[];
}

export default function ContactTypesSidebar({ messages }: ContactTypesSidebarProps) {
  const types = useMemo(() => {
    const map = new Map<string, "generic" | "youtube">();
    messages.forEach((m) => {
      const key = m.sender_email?.toLowerCase() ?? `no-email-${m.id}`;
      if (!map.has(key)) {
        map.set(key, m.comment_source);
      }
    });

    const contacts = Array.from(map.values());
    const generic = contacts.filter((s) => s === "generic").length;
    const youtube = contacts.filter((s) => s === "youtube").length;

    return [
      { label: "Memorial Page", count: generic },
      { label: "Youtube", count: youtube },
    ];
  }, [messages]);

  const total = types.reduce((sum, t) => sum + t.count, 0) || 1;

  return (
    <Paper
      sx={{
        borderRadius: 3,
        p: 2.5,
        boxShadow: 0,
        border: "1px solid #f1f5f9",
        mt: 2,
      }}
    >
      <Typography
        sx={{ fontWeight: 700, fontSize: "15px", color: "#1e293b", mb: 2 }}
      >
        Contacts Types
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {types.map((type) => (
          <Box key={type.label}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
            >
              <Typography sx={{ fontSize: "13px", color: "#475569" }}>
                {type.label}
              </Typography>
              <Typography
                sx={{ fontSize: "13px", color: "#475569", fontWeight: 600 }}
              >
                {type.count}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={(type.count / total) * 100}
              sx={{
                height: 6,
                borderRadius: 4,
                bgcolor: "#d9d9d9",
                "& .MuiLinearProgress-bar": {
                  bgcolor: "#afafaf",
                  borderRadius: 4,
                },
              }}
            />
          </Box>
        ))}
      </Box>
    </Paper>
  );
}